import { ResourceName } from "@/types";
import { ClientList } from "./ClientList";
import { ClientShow } from "./ClientShow";
import { getResourceIcon } from "@/utils/icons";

const ClientIcon = getResourceIcon(ResourceName.CLIENTS);

const resource = {
  list: ClientList,
  show: ClientShow,
  //edit:
  //create:
  icon: ClientIcon,
  recordRepresentation: (record: any) => `${record.name}`,
};

export default resource;
